import { render, staticRenderFns } from "./Analise.vue?vue&type=template&id=2b214159"
import script from "./Analise.vue?vue&type=script&lang=js"
export * from "./Analise.vue?vue&type=script&lang=js"
import style0 from "./Analise.vue?vue&type=style&index=0&id=2b214159&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports